// extracted by mini-css-extract-plugin
export var badge = "_go-2";
export var detailsPanel = "_go-0";
export var resultRow = "_go-1";